export default __webpack_public_path__ + "static/media/cemea-logo-nuage.8a015f56.png";